import { useAppConfiguration, useGraphqlQuery } from '@mews-commander/data-access';
import { graphql, MatchedGuestProfiles, NextMatchedGuestProfilesResultQuery } from '@mews-commander/guest-profile';
import { useCurrentEnterprise } from '@mews-commander/legacy-entities/src/enterprise';
import { transformGuestProfiles } from './transformGuestProfiles';

const NextMatchedGuestProfilesQueryDocument = graphql(`
    query nextMatchedGuestProfilesResult($chainId: UUID!, $previousMatchId: UUID) {
        nextMatchedGuestProfiles(chainId: $chainId, previousMatchId: $previousMatchId) {
            id
            confidence
            matchedFields
            mergeInfo {
                isMergePossible
                errorMessage
            }
            profiles {
                ...GuestProfileFields
            }
            preSelectedFields {
                field
                profileId
            }
        }
    }
`);

const transformToMatchedGuestProfiles = (
    data: NextMatchedGuestProfilesResultQuery
): MatchedGuestProfiles | undefined => {
    if (!data.nextMatchedGuestProfiles?.profiles) {
        return undefined;
    }
    const {
        nextMatchedGuestProfiles: { profiles, ...otherProps },
    } = data;

    return {
        profiles: transformGuestProfiles(profiles),
        ...otherProps,
    };
};

export const useNextMatchedGuestProfiles = (enabled: boolean, previousMatchId: string | null) => {
    const { chainId } = useCurrentEnterprise();
    const { guestProfileApiUrl } = useAppConfiguration();
    const { data, ...props } = useGraphqlQuery(
        guestProfileApiUrl,
        {
            document: NextMatchedGuestProfilesQueryDocument,
            variables: { chainId, previousMatchId },
        },
        {
            enabled,
            staleTime: 0,
        }
    );

    return {
        ...props,
        data: data ? transformToMatchedGuestProfiles(data) : undefined,
    };
};
